import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ArtworkCard from "@/components/ArtworkCard";
import { Loader2, Palette } from "lucide-react";

export default function ArtistProfile() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/artists/${id}`).then((r) => setData(r.data)).catch(() => {}); }, [id]);

  if (!data) return (<div><Navbar /><div className="flex justify-center py-32"><Loader2 className="w-8 h-8 animate-spin text-[var(--gold)]" /></div></div>);

  return (
    <div>
      <Navbar />
      <div className="bg-[var(--bg-dark)] text-white relative grain">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 flex items-center gap-6">
          <div className="w-20 h-20 rounded-full bg-[var(--gold)]/20 flex items-center justify-center text-[var(--gold)]">
            <Palette className="w-8 h-8" />
          </div>
          <div>
            <div className="overline-badge">Artist</div>
            <h1 className="font-serif text-4xl sm:text-5xl mt-1">{data.artist.name}</h1>
            {data.artist.bio && <p className="text-stone-400 mt-2 max-w-2xl">{data.artist.bio}</p>}
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h2 className="font-serif text-2xl mb-8">Works ({data.artworks.length})</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {data.artworks.map((a) => <ArtworkCard key={a.id} art={a} />)}
        </div>
      </div>
      <Footer />
    </div>
  );
}
